// header 通知按鈕
import { useDispatch, useSelector } from 'react-redux';
import notificationClient from '@/common/apiClient/notificationClient';
import { notificationState, setNotification } from '@/slices/notificationSlice';
import { sendReadStatus } from '@/common/socketFunctions';

const HeaderNotifyButton = ({ onClickNotify, uid }) => {
    const dispatch = useDispatch();
    const { notification } = useSelector(notificationState);
    const { records, unreadCnt } = notification;

    // 已讀通知
    const onRead = async () => {
        try {
            // 未讀的通知
            const unreadRecords = records?.slice(0, 3)?.filter(({ readTime }) => !readTime);
            if (!unreadRecords?.length) return;

            const personalIds = unreadRecords
                .filter((n) => n.type === 'personal')
                .map((n) => n.msgId);
            const publicIds = unreadRecords
                .filter((n) => n.type !== 'personal')
                .map((n) => n.msgId);

            const payload = {
                personalIds,
                publicIds,
            };

            // 更新通知讀取狀態
            await notificationClient.putNotifications(payload);

            // 已讀後重抓通知改變未讀數
            await getNotifications();

            await sendReadStatus({ uid, ...payload });
        } catch (e) {
            console.error(e);
        }
    };

    // 拿通知訊息資料
    const getNotifications = async () => {
        try {
            const { records, unreadCnt } = await notificationClient.getNotifications();

            if (records) dispatch(setNotification({ records, unreadCnt }));
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <button
            onClick={() => {
                onRead();
                onClickNotify();
            }}
            className="w-[32px] aspect-[1] rounded-[50%] center-center border-1 border-[rgba(170,130,195,0.32)] trans
            hover:bg-bou hover:border-bou group relative"
        >
            <span
                className="w-[20px] h-[20px] bg-contain bg-center trans group-hover:filter-white
            bg-[url('/images/icon/icon_notify.svg')]"
            />

            {/* 未讀通知 */}
            {unreadCnt > 0 && (
                <span
                    className="absolute bg-[#d3392f] w-[18px] h-[18px] rounded-[50%] top-[-3px] right-[-3px]
                text-white text-bd3n center-center z-[1] !filter-none"
                >
                    {/* 通知數量 */}
                    <span className="origin-center scale-[.75]">{unreadCnt}</span>
                </span>
            )}
        </button>
    );
};

export default HeaderNotifyButton;
